import { z } from 'zod';

export const reviewSchema = z.object({
  confirmed: z.literal(true, { errorMap: () => ({ message: 'mustAccept' }) }),
});
